import React from "react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { contact, stats, founder, whyChoose } from "../mock";
import * as Icons from "lucide-react";
import { MessageCircle, BadgeCheck } from "lucide-react";
import CmsContent from "../components/CmsContent";

const About = () => {
  return (
    <main>
      <PageHero
        crumb="About Us"
        title="About"
        highlight="DaddyAnna"
        subtitle="India's No.1 platform for online cricket id, live casino and sports exchange — trusted by players across the country since 2015."
      />

      <section className="py-14 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="space-y-5 text-gray-400 leading-relaxed text-lg">
              <p>
                Cricket is not merely a sport — it is an emotion. DaddyAnna was built to elevate the way India enjoys every match. We provide verified online cricket IDs that are 100% safe, fast and effortless to use.
              </p>
              <p>
                Whether it is the IPL, the World Cup or any domestic T20 league, you will find every match live on DaddyAnna, complete with real-time odds and over 650+ casino games to keep the excitement going all day.
              </p>
              <p>
                Our competitive edge comes from years of experience, complete transparency with our clients, a wide array of gaming options, certified IDs and round-the-clock customer support. We take pride in a community where players are looked after 24x7.
              </p>
            </div>
          </Reveal>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
            {stats.map((s, i) => (
              <Reveal key={i} delay={i * 80}>
                <div className="card-neon rounded-2xl p-6 text-center">
                  <div className="font-tech text-3xl font-bold neon-green text-glow-green">{s.value}</div>
                  <div className="mt-2 text-gray-400 text-sm">{s.label}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-[#08080f]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading eyebrow="Our Values" title="What We" highlight="Stand For" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {whyChoose.map((c, i) => {
              const Icon = Icons[c.icon] || Icons.Star;
              return (
                <Reveal key={c.title} delay={i * 90}>
                  <div className="card-neon rounded-2xl p-6 h-full">
                    <div className="h-12 w-12 grid place-items-center rounded-xl bg-[#00ff87]/10 text-[#00ff87] mb-4">
                      <Icon size={24} />
                    </div>
                    <h3 className="font-display font-semibold text-lg text-white mb-2">{c.title}</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">{c.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="rounded-3xl border border-[#00ff87]/15 bg-gradient-to-br from-[#0c0d17] to-[#0a0a13] p-8 md:p-12 grid md:grid-cols-[auto_1fr] gap-10 items-center">
              <div className="relative mx-auto">
                <div className="absolute inset-0 bg-[#00ff87]/25 blur-2xl rounded-full" />
                <img src={founder.avatar} alt={founder.name} className="relative z-10 h-44 w-44 rounded-full object-cover border-2 border-[#00ff87]/50" />
              </div>
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-display text-2xl font-bold text-white">{founder.name}</h3>
                  <BadgeCheck size={22} className="text-[#00e5ff]" />
                </div>
                <p className="text-[#00ff87] font-medium mb-4">{founder.role}</p>
                <p className="text-gray-400 leading-relaxed">{founder.bio}</p>
                <a href={contact.whatsapp} target="_blank" rel="noreferrer" className="btn-neon mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-xl font-display font-semibold">
                  <MessageCircle size={18} /> Chat with Us
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
      <CmsContent slug="about-us" fallbackTitle="About DaddyAnna | Online Cricket ID" />
    </main>
  );
};

export default About;
